  import { useState } from "react";
  import { DatePicker, Form, Input } from "antd";
  import { Control, UseFormResetField, UseFormSetValue } from "react-hook-form";
  import { FormItem } from "react-hook-form-antd";
  import { toDayjsDate } from "@shared/utils";
  import { DocumentSelector } from "../../../document-selector";
  import { DocumentItem } from "../../../generic-document-modal";

  interface RepresentationFormAddProps {
    control: Control<any>;
    resetField: UseFormResetField<any>;
    setValue?: UseFormSetValue<any>;
    isAddFromOldService?: boolean;
    onDocumentFromOldServiceSelect?: (document: DocumentItem) => void;
  }

  export const RepresentationFormAdd = ({
    control,
    resetField,
    setValue,
    isAddFromOldService = false,
    onDocumentFromOldServiceSelect,
  }: RepresentationFormAddProps) => {
    const [isDocumentFromListSelected, setIsDocumentFromListSelected] = useState(false);

    const handleDocumentSelect = (document: DocumentItem) => {
      if (setValue) {
        if (document.title) {
          setValue("name", document.title, { shouldValidate: true });
        }
        if (document.code) {
          setValue("number", document.code, { shouldValidate: true });
        }
        if (document.date) {
          setValue("issueDate", toDayjsDate(document.date), { shouldValidate: true });
        }
      }

      setIsDocumentFromListSelected(true);

      if (onDocumentFromOldServiceSelect) {
        onDocumentFromOldServiceSelect(document);
      }
    };

    const handleDocumentRemove = () => {
      if (setValue) {
        setValue("name", "", { shouldValidate: false });
        setValue("number", "", { shouldValidate: false });
        setValue("issueDate", null, { shouldValidate: false });
      }

      setIsDocumentFromListSelected(false);

      if (onDocumentFromOldServiceSelect) {
        onDocumentFromOldServiceSelect(null as any);
      }
    };

    return (
      <Form>
        <DocumentSelector
          control={control}
          accept={["application/pdf"]}
          label="Приказ о назначении сотрудника"
          triggerButtonLabel="Добавить документ"
          name="permit"
          className="confirmation-credentials-upload"
          resetField={resetField}
          isAddFromOldService={isAddFromOldService}
          setValue={setValue}
          onDocumentSelect={handleDocumentSelect}
          onDocumentRemove={handleDocumentRemove}
        />
        <div className="confirmation-credentials">
          <div className="confirmation-credentials-inputs-container">
            <div className="confirmation-credentials-label">
              <div className="confirmation-credentials-title">
                Наименование документа
              </div>
              <FormItem
                control={control}
                name="name"
                style={{ padding: 0, margin: 0 }}
              >
                <Input placeholder="Приказ" disabled={isDocumentFromListSelected} />
              </FormItem>
            </div>
            <div className="confirmation-credentials-label">
              <div className="confirmation-credentials-title">
                Номер документа
              </div>
              <FormItem
                control={control}
                name="number"
                style={{ padding: 0, margin: 0 }}
              >
                <Input placeholder="№ГГ-12" disabled={isDocumentFromListSelected} />
              </FormItem>
            </div>
            <div className="confirmation-credentials-label">
              <div className="confirmation-credentials-title">Дата выдачи </div>
              <FormItem
                control={control}
                name="issueDate"
                style={{ padding: 0, margin: 0 }}
              >
                <DatePicker placeholder="12.12.2012" format="DD.MM.YYYY" disabled={isDocumentFromListSelected} />
              </FormItem>
            </div>
          </div>
        </div>
        <div className="organization-credentials">
          <div className="organization-credentials-label">
            <div className="organization-credentials-title">
              Организация, выдавшая документ (необ.)
            </div>
            <FormItem
              control={control}
              name="organization"
              style={{ padding: 0, margin: 0 }}
            >
              <Input placeholder="" />
            </FormItem>
          </div>
          <div className="organization-credentials-label">
            <div className="organization-credentials-title">Описание (необ.)</div>
            <FormItem
              control={control}
              name="description"
              style={{ padding: 0, margin: 0 }}
            >
              <Input placeholder="" />
            </FormItem>
          </div>
        </div>
      </Form>
    );
  };
